/** Whether a pre-made prompt phrase is already part of the prompt. */
export function hasAiCoverPromptPreset(prompt: string, preset: string): boolean {
  const phrase = preset.trim();
  return phrase !== '' && prompt.includes(phrase);
}

/** Drops separators left dangling at either end after a removal. */
function tidy(prompt: string): string {
  return prompt
    .replace(/\s*\.\s*\.\s*/g, '. ')
    .replace(/^[\s.]+/, '')
    .replace(/[\s.]+$/, '')
    .replace(/\s{2,}/g, ' ');
}

/**
 * Adds a pre-made phrase to the AI cover prompt (after whatever the user
 * wrote), or removes it when it is already there. The user can still edit
 * the result freely. Adding never pushes the prompt past `maxLength`.
 */
export function toggleAiCoverPromptPreset(prompt: string, preset: string, maxLength = 1000): string {
  const phrase = preset.trim();
  if (!phrase) return prompt;
  if (hasAiCoverPromptPreset(prompt, phrase)) {
    return tidy(prompt.replace(phrase, ''));
  }
  const base = prompt.trim();
  if (!base) return phrase.length > maxLength ? prompt : phrase;
  const separator = /[.!?…]$/.test(base) ? ' ' : '. ';
  const next = `${base}${separator}${phrase}`;
  return next.length > maxLength ? prompt : next;
}
